import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useHistory } from "react-router-dom"
import login from "../../api/login";
import axios from "axios";
import { setUser } from "../../redux/userSlice"
import { showToastAction } from "../../redux/toastSlice";

const SigninForm = () => {
    const [state, setState] = useState({ username: "", password: "" })
    const dispatch = useDispatch();
    const history = useHistory()

    function handleChangeUsername(event) {
        setState({ ...state, username: event.target.value });
    }

    function handleChangePassword(event) {
        setState({ ...state, password: event.target.value });
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        const { username, password } = state;

        try {
            const res = await login(username, password);
            localStorage.setItem("access_token", res.data.Accesstoken);
            localStorage.setItem("user", res.data.user);
            localStorage.setItem("organization", res.data.organization);
            if (res) {
                let user_session = await axios.get("session-details");
                dispatch(setUser(user_session.data.data))
                history.push("/home")
            }
        }
        catch (err) {
            console.log(" err in handle submit ", err)
            dispatch(showToastAction({ message: "Invalid username or password", showToast: true }))
        }
    }

    return (
        <div>
            <h2 className="mb-3">Login</h2>
            <form id="contact-form" onSubmit={handleSubmit} >
                <div className="messages" />
                <div className="form-group">
                    <input id="form_name" value={state.username} onChange={handleChangeUsername} type="text" name="username" className="form-control" placeholder="Username" required="required" data-error="Username Required" />
                    <div className="help-block with-errors" />
                </div>
                <div className="form-group">
                    <input value={state.password} onChange={handleChangePassword} id="form_password" type="password" name="password" className="form-control" placeholder="Mot de passe" required="required" data-error="Password Required" />
                    <div className="help-block with-errors" />
                </div>
                <div className="form-group mt-4 mb-5">
                    <div className="remember-checkbox d-flex align-items-center justify-content-between">
                        <Link to="/forgot-password">Forgot Password</Link>
                    </div>
                </div>    <button type="submit" className="btn btn-primary btn-block">Se connecter</button>
            </form>
            {/* <div className="d-flex align-items-center text-center justify-content-center mt-4">
                <span className="text-muted mr-1">Don't have an account ?</span>
                <Link to="/sign-up">Register</Link>
            </div> */}
        </div>
    )
}

export default SigninForm
